import { Select, MenuItem } from '@mui/material';
import { Label } from '../../../common/Label/Label';
import FilterSearchBox from '../FilterPanel/FilterSearchBox/FilterSearchBox';
import styles from './SearchAndSort.module.scss';
import { SearchAndSortProps } from './SearchAndSort.types';
import { RightArrow } from '../../../../lib/icons/RightArrow';
import { searchAndSortIds } from '../../../../lib/tests/testIds';
import Layout from '../../../common/Layout/Layout';
import { classes } from '../../../../lib/utils/cssUtils';
import { useDirectionLabel, SortValue } from '../../../../lib/hooks/labels';
import { CY_SEARCH_AND_SORT } from '../../../../lib/constants/cypress';

const WrappedArrowIcon = () => (
  <span className={styles.sortIconContainer}>
    <RightArrow />
  </span>
);

export const SearchAndSort = ({
  onSearchChange,
  onSortChange,
  labels,
  searchValue,
  activeSortValue,
  sortValues,
  className,
}: SearchAndSortProps) => {
  const getDirectionLabel = useDirectionLabel();

  const sortValuesWithDirection = (sortValues as SortValue[])?.map(({ value, labelKey }) => ({
    value,
    labelKey,
    labelKeyDirection: getDirectionLabel({ value }),
  }));

  return (
    <div className={classes(styles.container, className)}>
      <Layout>
        <div className={styles.innerContainer}>
          <FilterSearchBox
            className={styles.searchBox}
            value={searchValue ?? ''}
            onChange={onSearchChange}
            customPlaceholderKey={labels.searchPlaceholder}
            dataTestId={searchAndSortIds.searchSelector}
          />
          <div className={styles.sortingContainer}>
            <Label name={labels.sortTeamsBy} className={styles.sortByTitle} />
            <Select
              className={styles.selectRoot}
              classes={{ select: styles.selectSortInput, icon: styles.sortIcon }}
              value={activeSortValue}
              onChange={onSortChange}
              IconComponent={WrappedArrowIcon}
              MenuProps={{
                classes: { paper: styles.optionItemsContainer, list: styles.optionList },
                disableScrollLock: true,
              }}
              variant="outlined"
              data-testid={searchAndSortIds.sortSelector}
              data-cy={CY_SEARCH_AND_SORT.SORT_SELECTOR}
            >
              {sortValuesWithDirection?.map(({ value, labelKey, labelKeyDirection }) => (
                <MenuItem
                  key={value}
                  classes={{ selected: styles.sortValueItem }}
                  className={styles.selectItem}
                  value={value}
                >
                  <Label name={labelKey} />
                  &nbsp;
                  <Label name={labelKeyDirection} />
                </MenuItem>
              ))}
            </Select>
          </div>
        </div>
      </Layout>
    </div>
  );
};
